import { useEffect, useRef, type FC } from 'react';

/*
    A script tag in JSX never runs. Append the third-party script once, and only for a course with a
    CourseTalk id.
*/

const SCRIPT_SRC = 'https://d3q6qq2zt8nhwv.cloudfront.net/s/js/widgets/coursetalk-reviews.js';

type Props = {
    courseTalkId: number | null;
    className?: string;
};

export const CourseTalkReviewWidget: FC<Props> = ({ courseTalkId, className }) => {
    const container = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!courseTalkId || !container.current) return undefined;

        const script = document.createElement('script');
        script.src = SCRIPT_SRC;
        script.async = true;
        container.current.appendChild(script);

        return () => script.remove();
    }, [courseTalkId]);

    if (!courseTalkId) return null;

    return (
        <div ref={container} className={className}>
            <div
                id="ct-custom-read-review-widget"
                data-provider="smartly"
                data-course={courseTalkId}
                data-theme="nextgen-smartly"
            />
        </div>
    );
};
